import type { CheckoutCartHistoryItem, CheckoutKiosk } from '@gozoki/api-types'
import { gozokiApiWithAuth } from '../gozokiApi'

export const fetchCheckoutKiosks = async (storeId: number) => {
  const response = await gozokiApiWithAuth.get<CheckoutKiosk[]>(`/stores/${storeId}/checkouts`)
  return response.data
}

export const fetchRecentCheckoutCarts = async (storeId: number) => {
  const response = await gozokiApiWithAuth.get<CheckoutCartHistoryItem[]>(
    `/stores/${storeId}/checkouts/recent-carts`,
  )
  return response.data
}
